<h2 mat-dialog-title>What this settlement pays</h2>

<mat-dialog-content>
  <p class="hint">
    {{ data.settlement.supplier_name }} · {{ data.settlement.created_at | date:'medium' }} · {{ data.settlement.status }}
  </p>

  @if (loading) {
  <div class="center"><mat-spinner diameter="28"></mat-spinner></div>
  } @else if (error) {
  <div class="center err">{{ error }}</div>
  } @else if (items) {
  @if (items.runs.length === 0 && items.contracts.length === 0) {
  <p class="empty">
    @if (data.settlement.kind !== 'Payout') {
    This is a {{ data.settlement.kind }}: it covers no transfer runs or contracts. See its note for what it is for.
    } @else {
    No transfer runs or contracts are linked to this settlement any more (they were marked unpaid after it was recorded).
    }
  </p>
  }

  @if (items.runs.length) {
  <h3>Transfer runs ({{ items.runs.length }})</h3>
  <div class="table-wrap">
    <table>
      <thead>
        <tr><th>Account</th><th>Finished</th><th>Status</th><th class="num">Coins</th><th class="num">Fee</th><th class="num">Amount</th></tr>
      </thead>
      <tbody>
        @for (r of items.runs; track r.id) {
        <tr>
          <td>{{ r.account_email }}</td>
          <td>{{ (r.confirmed_at || r.started_at) | date:'short' }}</td>
          <td>{{ r.status }}</td>
          <td class="num">{{ r.coins_transferred | number }}</td>
          <td class="num">{{ r.fee_snapshot | number }}</td>
          <td class="num">{{ r.payable_amount | number }}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }

  @if (items.contracts.length) {
  <h3>Manual contracts ({{ items.contracts.length }})</h3>
  <div class="table-wrap">
    <table>
      <thead>
        <tr><th>Contract</th><th>Created</th><th>Status</th><th class="num">Coins received</th><th class="num">Fee</th><th class="num">Amount</th></tr>
      </thead>
      <tbody>
        @for (c of items.contracts; track c.id) {
        <tr>
          <td>{{ c.name || c.id.slice(0, 8) }}</td>
          <td>{{ c.created_at | date:'short' }}</td>
          <td>{{ c.status }}</td>
          <td class="num">{{ c.received_coins | number }}</td>
          <td class="num">{{ c.fee | number }}</td>
          <td class="num">{{ c.payable_amount | number }}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }

  @if (items.runs.length || items.contracts.length) {
  <div class="totals">
    <span>Coins: <strong>{{ coinsTotal | number }}</strong></span>
    <span>Items total: <strong>{{ itemsTotal | number }}</strong></span>
    <span>Settlement amount: <strong>{{ data.settlement.amount | number }}</strong></span>
  </div>
  @if (itemsTotal !== data.settlement.amount) {
  <p class="warn">
    The items no longer add up to the recorded amount — some were marked unpaid (detached) after this settlement was recorded.
  </p>
  }
  }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close type="button">Close</button>
</mat-dialog-actions>
